'use client';
import { useCallback, useEffect, useState } from 'react';

/**
 * Custom hook for calculating the optimal position for the dropdown menu
 * Ensures the menu stays within viewport bounds
 */
export const useMenuPosition = (
  anchorRef: React.RefObject<HTMLElement | null>,
  isOpen: boolean,
) => {
  const [position, setPosition] = useState<{ top: number; right: number } | null>(null);

  const updatePosition = useCallback(() => {
    if (!anchorRef.current) return;
    const rect = anchorRef.current.getBoundingClientRect();
    const rightOffset = window.innerWidth - rect.right;
    setPosition({
      top: rect.bottom + 8,
      right: rightOffset > 16 ? rightOffset : 16,
    });
  }, [anchorRef]);

  useEffect(() => {
    if (!isOpen) return;

    updatePosition();

    window.addEventListener('resize', updatePosition);
    return () => window.removeEventListener('resize', updatePosition);
  }, [isOpen, updatePosition]);

  return position;
};
